import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: false,
	name: 'maskPan'
})
export class MaskPanPipe implements PipeTransform {

	transform(value: any): any {
		if (value === undefined || value === null || value === '') {
			return value;
		}
		const pan = String(value);
		if (pan.length <= 4) {
			return pan;
		}
		return '*'.repeat(pan.length - 4) + pan.substr(pan.length - 4);
	}
}
